module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.L. Stine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, "), _c('I', [_vm._v("The Little Shop of Monsters")]), _vm._v(" and "), _c('I', [_vm._v("Mary McScary")]), _vm._v(". R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ADMFxy/tc-custom/9780545841009.jpg?1709154777819",
      "alt": "This image is the cover for the book Tick Tock, You're Dead!, Give Yourself Goosebumps"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tick Tock, You're Dead!, Give Yourself Goosebumps\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Take a terrifying trip through time in this scary GOOSEBUMPS adventure that’s packed with more than twenty super-spooky endings.")]), _c('br'), _c('br'), _vm._v("B-O-R-I-N-G. That’s how you’d describe your family vacation in New York City. Instead of visiting all the cool spots, like Rockefeller Center and the Statue of Liberty, your parents drag you to a bunch of stupid museums. Then, at the Museum of Natural History something really strange happens. You accidentally get involved in a strange experiment that sends you traveling through time! Will you duel with knights at a medieval castle? Come face-to-face with a man-eating dinosaurs? Or take a ride through outer space?"), _c('br'), _c('br'), _c('b', [_vm._v("Reader beware—you choose the scare! GIVE YOURSELF GOOSEBUMPS!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0